import React from 'react'
import { sectionAnchor } from '../../lib/guide-presentation.mjs'
import Content from '../block-content/block-content'
import { Section } from '../section/section.component'
import { sanitySrcUrl } from '../../lib/libFunctions'
import { imageStyles } from '../../styles/base/_allBase.styles'
import { CustomButton } from '../button/button.component'
import { analyticsModuleAttributes } from '../../lib/analytics-content.mjs'
import {
  BlogSectionWrapper,
  CenteredButton,
  CopyBlock,
  EditorialNumber,
  HeadingBlock,
  ImageWrapper,
  SectionDeck,
  SectionHeading,
} from './blog-content-section.styles'

const { ImgCover } = imageStyles

export default function BlogContentSection({
  data,
  index = 0,
  total = 1,
  layout = 'prose',
  variant = 'article',
  numberSections = true,
}) {
  if (!data) return null
  const { header, subHeader, image, content, ctaLabel, ctaSlug } = data
  const sectionLabel = variant === 'article' && numberSections
    ? `${String(index + 1).padStart(2, '0')} / ${String(total).padStart(2, '0')}`
    : null

  return (
    <Section
      id={sectionAnchor(data)}
      size="auto"
      cursorsize="small"
      {...analyticsModuleAttributes(data, 'article_section', index, header)}
    >
      <BlogSectionWrapper $layout={layout} data-layout={layout} data-variant={variant}>
        {sectionLabel && <EditorialNumber aria-label={`Section ${index + 1} of ${total}`}>{sectionLabel}</EditorialNumber>}
        <HeadingBlock>
          {header && (
            <SectionHeading>{header}</SectionHeading>
          )}
          {subHeader && (
            <SectionDeck>{subHeader}</SectionDeck>
          )}
        </HeadingBlock>
        {image && (
          <ImageWrapper>
            <ImgCover
              src={sanitySrcUrl(image)}
              alt={image.alt || header}
              sizes="(max-width: 899px) 100vw, 55vw"
              fill
            />
          </ImageWrapper>
        )}
        {content && (
          <CopyBlock>
            <Content blocks={content} />
          </CopyBlock>
        )}
        {ctaLabel && ctaSlug && (
          <CenteredButton>
            <CustomButton
              href={ctaSlug}
              external={ctaSlug.startsWith('http')}
              data-analytics-cta-id={`${data._key || index}-cta`}
              data-analytics-cta-label={ctaLabel}
              data-analytics-placement-id="article-section"
            >
              {ctaLabel}
            </CustomButton>
          </CenteredButton>
        )}
      </BlogSectionWrapper>
    </Section>
  )
}
